<template v-if="renderComponent">
	<!-- <FormCard> -->
	<div class="flex items-center justify-between w-full gap-2 mb-4">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '')"
			>{{ tabName + " - " + subTabName }}
		</PageLabel>
		<div class="flex flex-row items-center gap-2">
			<Button id="btnback" v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)" @click.stop="changePage('prev')">Back </Button>
			<Button id="btnSaveGeneralInformation" @click.prevent="saveUtilities(true)" v-bind="lock.button.value" v-tooltip="lock.tooltip">Save</Button>
			<Button
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('next')"
			>
				Next
			</Button>
		</div>
	</div>

	<!-- Energy Multipliers Section - Only for specific screens -->
	<div v-if="showEnergyMultipliers" class="flex flex-col gap-2 bg-white shadow sm:rounded-lg p-4 mb-6">
		<div class="flex items-center justify-between w-full gap-2 mb-4">
			<PageLabel helpPageName="EnergySourceMultipliers">Energy Source Multipliers</PageLabel>
			<div class="flex gap-2" v-if="!energyMultipliersEditMode">
				<Button
					v-if="energyMultipliersType === 'assessment'"
					class="btn btn-primary"
					@click="enterEnergyMultipliersEditMode()"
					type="button"
					v-bind="lock.button.value"
					v-tooltip="lock.tooltip"
				>
					Edit
				</Button>
			</div>
			<div class="flex gap-2" v-else>
				<Button class="btn btn-secondary" @click="cancelEnergyMultipliersEdit()" type="button">Cancel</Button>
				<Button class="btn btn-primary" @click="saveEnergyMultipliers()" type="button">Save</Button>
			</div>
		</div>

		<!-- Type Selection -->
		<div class="flex justify-start mb-4">
			<div
				class="flex align-items-center gap-3"
				v-tooltip="isCalculateByReferenceUnit ? 'Global defaults are not available when calculating results by reference unit' : undefined"
			>
				<label class="font-medium">Global Default</label>
				<ToggleSwitch
					:model-value="isCalculateByReferenceUnit ? true : energyMultipliersType === 'assessment'"
					@update:model-value="(value) => onSwitchChange(value)"
					:disabled="isCalculateByReferenceUnit || assessmentStore.isLocked"
				/>
				<label class="font-medium">Assessment Specific</label>
			</div>
		</div>

		<!-- Energy Multipliers Table -->
		<div class="w-full">
			<DataTable :value="energyMultipliers" :loading="energyMultipliersLoading" stripedRows showGridlines responsiveLayout="scroll">
				<template #empty>
					<div class="flex items-center justify-center gap-3 p-4">
						<WarningIcon v-if="!energyMultipliersLoading" errorType="Warning" :tooltipText="[energyMultipliersEmptyMessage]" size="2x" />
						<span v-if="!energyMultipliersLoading" class="font-bold">{{ energyMultipliersEmptyMessage }}</span>
					</div>
				</template>

				<Column field="energy.energyName" :sortable="!energyMultipliersEditMode">
				<template #header><I2Label label="Energy Type" helpElementName="UtilitiesSingleStepEnergyMultiplierEnergyType" /></template>
					<template #body="{ data }">
						<div>
							{{ data.energy?.energyName || "N/A" }}
						</div>
					</template>
				</Column>

				<Column field="value" :sortable="!energyMultipliersEditMode">
				<template #header><I2Label :label="enerySourceUnit" helpElementName="UtilitiesSingleStepEnergyMultiplierValue" /></template>
					<template #body="{ data }">
						<div v-if="!energyMultipliersEditMode">
							{{ formatValue(data.value) }}
						</div>
						<div v-else>
							<I2InputDecimal
								v-model="data.value"
								placeholder="Enter multiplier value"
								:inputClass="{ 'p-invalid': isEnergyMultiplierFieldInvalid(data, 'value') }"
								:allowNegative="false"
								class="w-full"
								@update:rawModelValue="(val) => energyMultiplierRawValues.set(data.energyId, val)"
							/>
						</div>
					</template>
				</Column>
			</DataTable>
		</div>
	</div>

	<I2FormRow class="mt-2 mb-2">
		<I2FormField label="Notes" helpElementName="UtilitiesNotes">
			<Textarea v-model="notes" placeholder="Please enter notes" rows="2" v-bind="lock.input.value" v-tooltip="lock.tooltip" />
		</I2FormField>
	</I2FormRow>
	<I2FormRow v-if="props.tabName === tabsDefinitions.biologics.value">
		<I2FormField label="Bulk Drug Substance (Dry Weight) Mass Output">
			{{ BDSMassOutput }}
		</I2FormField>
		<I2FormField label="Concentration of BDS in Production Bioreactor">
			{{ BDSConcentration }}
		</I2FormField></I2FormRow
	>
	<I2FormRow v-if="props.tabName === tabsDefinitions.biologics.value">
		<I2FormField label="Site Location">
			{{ siteLocation }}
		</I2FormField>
		<I2FormField label="Unit Operations" v-if="props.tabName === tabsDefinitions.syntheticAPI.value">
			{{ unitOperation }}
		</I2FormField></I2FormRow
	>
	<div class="flex items-center justify-between w-full gap-2 mb-4 mt-6">
		<PageLabel helpPageName="FuelForHeat">Fuel for Heat</PageLabel>
		<div class="flex flex-row items-center gap-2">
			<Button class="btn" @click="setConsumptionDefaults('fuel')" v-bind="lock.button.value" v-tooltip="lock.tooltip">Apply Default Values</Button>
		</div>
	</div>
	<div>
		<DataTable
			:v-if="displaySteamConsumptionList"
			:value="steamConsumptionList"
			responsiveLayout="scroll"
			:row-hover="true"
			dataKey="id"
			filterDisplay="menu"
			:loading="dataLoading"
			id="dtSteamConsumptionList"
			:class="{ 'invalid-table': saveAttempted && totalSteamConsumption != 100, '': totalSteamConsumption === 100 }"
		>
			<template #empty> No Steam Consumption found. </template>
			<template #loading>
				<div style="text-align: center; padding: 1rem">
					<FontAwesomeIcon :icon="['fa', 'spinner']" size="3x" class="text-blue-500 mt-3 ml-2" spin />
					<p style="color: white !important">Loading Steam Consumption data, please wait...</p>
				</div>
			</template>
			<Column field="natualGas">
			<template #header><I2Label label="Natural Gas (%)" helpElementName="UtilitiesSingleStepSteamConsumptionNaturalGas" /></template>
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.natualGas }} -->
						<InputText
							v-model="naturalGasValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'natualGas')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="coal">
			<template #header><I2Label label="Coal (%)" helpElementName="UtilitiesSingleStepSteamConsumptionCoal" /></template>
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.coal }} -->
						<InputText
							v-model="coalValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'coal')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="diesel">
			<template #header><I2Label label="Diesel (%)" helpElementName="UtilitiesSingleStepSteamConsumptionDiesel" /></template>
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.diesel }} -->
						<InputText
							v-model="dieselValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'diesel')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="biomass">
			<template #header><I2Label label="Biomass (%)" helpElementName="UtilitiesSingleStepSteamConsumptionBiomass" /></template>
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.biomass }} -->
						<InputText
							v-model="biomassValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'biomass')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="biomass">
			<template #header><I2Label label="Total (%)" helpElementName="UtilitiesSingleStepSteamConsumptionTotal" /></template>
				<template #body="{ data }">
					<div class="w-full" :style="'color:' + checkIfTotalIs100(totalSteamConsumption) + ';font-weight:bold'">
						<b>{{ totalSteamConsumption }}</b>
					</div>
				</template>
			</Column>
		</DataTable>
	</div>
	<div class="flex items-center justify-between w-full gap-2 mb-4 mt-6">
		<PageLabel helpPageName="ElectricityConsumption">Electricity Consumption</PageLabel>
		<div class="flex flex-row items-center gap-2">
			<Button class="btn" @click="setConsumptionDefaults('energy')" v-bind="lock.button.value" v-tooltip="lock.tooltip">Apply Default Values</Button>
		</div>
	</div>
	<I2FormRow class="flex mt-4 mb-2">
		<DataTable
			:v-if="displayEnergyConsumptionList"
			:value="energyConsumptionList"
			responsiveLayout="scroll"
			:row-hover="true"
			dataKey="id"
			filterDisplay="menu"
			:loading="dataLoading"
			id="dtEnergyConsumptionList"
			class="w-full"
			:class="{ 'invalid-table': saveAttempted && totalEnergyConsumption != 100, '': totalEnergyConsumption === 100 }"
		>
			<template #empty> No Electricity Consumption found. </template>
			<template #loading>
				<div style="text-align: center; padding: 1rem">
					<FontAwesomeIcon :icon="['fa', 'spinner']" size="3x" class="text-blue-500 mt-3 ml-2" spin />
					<p style="color: white !important">Loading Electricity Consumption data, please wait...</p>
				</div>
			</template>
			<Column field="gridAverageMix">
			<template #header><I2Label label="Grid (Average Mix) (%)" helpElementName="UtilitiesSingleStepEnergyConsumptionGridAverageMix" /></template>
				<template #body="{ data }">
					<div class="w-full">
						<InputText
							v-model="gridAverageMixValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							@change="checkIfEmpty('energyConsumption', 'gridAverageMix')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="renewable">
			<template #header><I2Label label="Renewables (%)" helpElementName="UtilitiesSingleStepEnergyConsumptionRenewables" /></template>
				<template #body="{ data }">
					<div class="w-full">
						<InputText
							v-model="renewableValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							@change="checkIfEmpty('energyConsumption', 'renewable')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="onSiteBiomass">
			<template #header><I2Label label="Total (%)" helpElementName="UtilitiesSingleStepEnergyConsumptionTotal" /></template>
				<template #body="{ data }">
					<div class="w-full" :style="'color:' + checkIfTotalIs100(totalEnergyConsumption) + ';font-weight:bold'">
						{{ totalEnergyConsumption }}
					</div>
				</template>
			</Column>
		</DataTable>
	</I2FormRow>

	<!-- <div class="flex items-center justify-between w-full gap-2 mb-4 mt-12"> 
		<div></div>
		<div class="flex flex-row items-center gap-2">
			<Button
				class="btn btn-outline"
				id="btnback"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('prev')"
			>
				Back
			</Button>
			<button id="btnSaveGeneralInformation" class="btn" @click="saveUtilities(true)">Save</button>
			<button
				class="btn"
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('next')"
			>
				Next
			</button>
		</div>
	</div> -->

	<!-- <div class="flex gap-2 mt-5 mb-5">
		<div style="width: 80%">&nbsp;</div>
		<div class="flex flex-row items-center gap-2">

			<Button
				class="btn btn-outline"
				id="btnback"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('prev')"
			>
				Back
			</Button>
			<button id="btnSaveGeneralInformation" class="btn" @click="saveUtilities()">Save</button>
			<button
				class="btn"
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('next')"
			>
				Next
			</button>
		</div>
	</div> -->
	<!-- </FormCard> -->
	<!-- <Toast position="top-right" /> -->
</template>

<script setup lang="ts">
import { ref, onMounted, watchEffect, watch, PropType, computed } from "vue"
import Textarea from "primevue/textarea"
import Select from "primevue/select"
import InputText from "primevue/inputtext"
import I2InputDecimal from "@/crispify/crispy-components/I2InputDecimal.vue"
import Checkbox from "primevue/checkbox"
import Button from "primevue/button"
import {
	ApiClient,
	Assessment,
	Screen,
	GeneralInformation,
	Step,
	Utilities,
	RawMaterialUnitOperation,
	UnitOperationStep,
	SteamConsumptionDefault,
	EnergyConsumptionDefault,
	Unit,
	UtilitiesSteamConsumption,
	UtilitiesEnergyConsumption,
	EnergyMultipliersClient,
	EnergyMultipliers,
	EnergySource,
	GeneralInformationClient,
} from "../../entities/NSwagGenerated"
import { SessionInfo, PageAccess } from "../auth/personSessionData"
//import commonStep from "../components/commonStep.vue"
import { useToast } from "primevue/usetoast"
import { useConfirm } from "primevue/useconfirm"
import { EventBus } from "@/eventBus"
import DataTable, { DataTableRowEditCancelEvent } from "primevue/datatable"
import Column from "primevue/column"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faInfoCircle, faTrash, faPen, faFloppyDisk, faXmarkLarge, faWarning } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
library.add(faTrash, faPen, faInfoCircle, faFloppyDisk, faXmarkLarge, faWarning)
import WarningIcon from "./warningIcon.vue"
import I2Label from "@/crispify/crispy-components/I2Label.vue"

import { getCurrentInstance } from "vue"
import { nextTick } from "vue"
import ToggleSwitch from "primevue/toggleswitch"
import { faXmark } from "@fortawesome/pro-solid-svg-icons"
import { uiNumberFormatterAZ } from "../composables/AZGlobalFunctions"
import { useTabsDefinitions } from "../composables/tabsDefinitions"
import { useHistoryHelper } from "../composables/historyHelper"
import { getEmptyGuid } from "@/composables/guidUtils"
import { util } from "zod/v4/core"
import { useAssessmentStore } from "@/store/assessmentStore"
import { useAssessmentLock } from "@/composables/assessmentLock"

const assessmentStore = useAssessmentStore()
const lock = useAssessmentLock(assessmentStore)
const tabsDefinitions = useTabsDefinitions()
const { updateAssessmentUpdatedByDate } = useHistoryHelper()

const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
import { createHighPrecisionAxios, patchEntityForPrecision } from "@/composables/highPrecisionDecimal"
const energyMultipliersClient = new EnergyMultipliersClient(import.meta.env.VITE_API_URL?.toString(), createHighPrecisionAxios())
const confirmDialog = useConfirm()

const props = defineProps({
	assessmentId: {
		type: String,
		required: true,
		default: "",
	},
	generalInformationId: {
		type: String,
		required: false,
		default: undefined,
	},
	tabName: {
		type: String,
		required: true,
		default: "",
	},
	subTabName: {
		type: String,
		required: true,
		default: "",
	},
	tabId: {
		type: String,
		required: true,
		default: "",
	},
	allTabsInformation: {
		type: Object,
		required: true,
		default: "",
	},
})

let step = new Step()
const notes = ref()
const stepName = ref("")
const stepNumber = ref("")
let utilities = new Utilities()
const projectData = ref()
const isSingleUtilitiesChecked = ref(false)
const step1Id = ref()
let dataLoading = ref(false)
const selectedUnitId = ref()
const calculatedCF = ref()
const stepId = ref()
const actualGeneralInformation = ref()
const isCalculateByReferenceUnit = ref(false)
let toast = useToast()
const utilitiesSteamConsumptionObj: UtilitiesSteamConsumption = new UtilitiesSteamConsumption()
const utilitiesEnergyConsumptionObj: UtilitiesEnergyConsumption = new UtilitiesEnergyConsumption()
const naturalGasValue = ref(0)
const coalValue = ref(0)
const dieselValue = ref(0)
const biomassValue = ref(0)
const gridAverageMixValue = ref(0)
const renewableValue = ref(0)
const totalSteamConsumption = ref(0)
const totalEnergyConsumption = ref(0)

const renderComponent = ref(true)
const displayUnitOperation = ref(false)
const displaySteamConsumptionList = ref(false)
const hasProductProcessTab = ref(false)
const displayEnergyConsumptionList = ref(false)
const saveAttempted = ref(false)
const saveUtilitiesData = ref(false)

const rawMaterialUnitOperation = ref([] as RawMaterialUnitOperation[])
const unitOperationStep = ref([] as UnitOperationStep[])
const steamConsumptionDefaultList = ref([] as SteamConsumptionDefault[])
const energyConsumptionDefaultList = ref([] as EnergyConsumptionDefault[])
const steamConsumptionList = ref([] as UtilitiesSteamConsumption[])
const energyConsumptionList = ref([] as UtilitiesEnergyConsumption[])
const unitList = ref([] as Unit[])

const thisStepStatus = ref(false)

//data from RawMaterials
const BDSMassOutput = ref()
const BDSConcentration = ref()
const siteLocation = ref()
const unitOperation = ref()

//WFI section removed

const nextPrevEnabled = ref(false)

//autosave
const actualUilitiesId = ref()

//editing
const editMode = ref()
editMode.value = "cell"

const steamConsumptionErrorFlagged = ref(false)
const energyConsumptionErrorFlagged = ref(false)

// Energy Multipliers variables
const energyMultipliers = ref([] as EnergyMultipliers[])
const originalEnergyMultipliers = ref([] as EnergyMultipliers[])
const energySources = ref([] as EnergySource[])
const energyMultipliersEditMode = ref(false)
const energyMultipliersType = ref("global") // "global" or "assessment"
const energyMultipliersSaveAttempted = ref(false)
const energyMultipliersLoading = ref(false)
const energyMultiplierRawValues = new Map<string, string | null>()
const showEnergyMultipliers = ref(false)

class tabActualStatus {
	actualMainTabId: string
	actualSubTabName: string
	selectedStepId: string
	generalInformationId: string
}

class allTabsActualStatus {
	public allTabsStatus: tabActualStatus[]
}
onMounted(() => {
	//getUtilitiesProcessingOperationByStepId()
	getAllUnit()
	getProjectData()
	// WFI and Cold Storage initialization removed

	// Check if Product Process tab exists for proper messaging
	checkSubprojectHasProductProcess()

	// Initialize energy multipliers - only check if screen is allowed, don't load data yet in onMounted
	showEnergyMultipliers.value = checkIfAllowedScreen()

	// Watch for changes in actualGeneralInformation to load energy multipliers when data is ready
	watch(actualGeneralInformation, async (newValue, oldValue) => {
		if (newValue && newValue !== oldValue) {
			// Reset cached step1Id so it gets re-fetched for the new packaging format
			step1Id.value = null

			initializeEnergyMultipliers()
		}
	})

	EventBus.on("selectedStep_" + props.tabId, (data: any) => {
		stepId.value = data.id
		stepName.value = data.stepName
		stepNumber.value = data.stepNumber
		const generalInformationChanged = actualGeneralInformation.value !== data.generalInformationId
		actualGeneralInformation.value = data.generalInformationId

		// Reload utilities data for the new step/generalInformation
		getUtilitiesByStepId(getEffectiveStepId())
		// When generalInformationChanged, the actualGeneralInformation watcher fires initializeEnergyMultipliers();
		// only trigger here when the watcher won't fire (same GI id) to avoid concurrent runs.
		if (!generalInformationChanged) {
			initializeEnergyMultipliers()
		}
	})
	EventBus.on("UtilitiesUpdate" + props.tabId, () => {
		saveAttempted.value = false
		const previousGeneralInformation = actualGeneralInformation.value
		setPrimaryInformation().then(() => {
			getUtilitiesByStepId(getEffectiveStepId())
			// If setPrimaryInformation changed the GI id, the watcher already ran initializeEnergyMultipliers();
			// only call directly when it didn't, so the tab still refreshes on re-view.
			if (actualGeneralInformation.value === previousGeneralInformation) {
				initializeEnergyMultipliers()
			}
		})
	})
	EventBus.on("nextPrevEnabled_" + props.tabId, () => {
		nextPrevEnabled.value = true
	})

	// Enable Next/Prev buttons immediately on mount
	EventBus.emit("nextPrevEnabled_" + props.tabId)
})

const enerySourceUnit = computed(() => {
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			return "kWh per kg API"
		case tabsDefinitions.biologics.value:
			return "kWh per kg wet BDS"
		case tabsDefinitions.productProcess.value:
			return "kWh/unit"
		case tabsDefinitions.packaging.value:
			return "kWh/unit"
		default:
			return "kWh/unit"
	}
})

function checkIfSteamElectricityAre100Perc(showToast: boolean = true) {
	// Skip validation if data is still loading or not yet initialized
	if (!displaySteamConsumptionList.value && !displayEnergyConsumptionList.value) {
		return true
	}

	var errors: boolean = false
	var errortext = []
	if (displaySteamConsumptionList.value && totalSteamConsumption.value !== 100) {
		errors = true
		errortext.push("Steam Consumption")
	}
	if (displayEnergyConsumptionList.value && totalEnergyConsumption.value !== 100) {
		errors = true
		errortext.push("Energy Consumption")
	}
	if (errors) {
		if (showToast) {
			var errorsText =
				"Please check " + (errortext.length > 1)
					? errortext.join(" & ")
					: errortext[0] + (errortext.length > 1)
						? " both "
						: "" + "need" + (errortext.length > 1)
							? "s"
							: "" + " to reach 100% as total"
			toast.add({
				severity: "error",
				summary: "Error",
				detail: "Please check " + errorsText + " to reach 100% as total",
			})
		}
		return false
	} else {
		return true
	}
}
const formatValue = (value: number | null | undefined): string => {
	if (value === null || value === undefined) return "0"

	// Format with comma for thousands and dot for decimals
	return value.toLocaleString("en-US", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 8,
	})
}

// Function to check if subproject has Product Process screen via API
async function checkSubprojectHasProductProcess(): Promise<void> {
	if (!props.assessmentId) return

	try {
		const result = await apiClient.checkIfSubprojectHasProductProcessScreen(props.assessmentId)
		hasProductProcessTab.value = result
	} catch (error) {
		console.error("Error checking if subproject has Product Process screen:", error)
		hasProductProcessTab.value = false
	}
}

// Computed property for the energy multipliers empty message
const energyMultipliersEmptyMessage = computed(() => {
	if (props.tabName === tabsDefinitions.syntheticAPI.value || props.tabName === tabsDefinitions.productProcess.value) {
		// Synthetic API or Product Process tab
		return "Please select a Product Format in the General Information tab to load energy multipliers."
	} else if (props.tabName === tabsDefinitions.packaging.value) {
		// Device & Packaging tab
		if (hasProductProcessTab.value) {
			return "Please select a Product Format in the Product Process General Information tab to load energy multipliers."
		} else {
			return "Please select a Product Format in the General Information tab to load energy multipliers."
		}
	}
	return "No energy multipliers found."
})

// updateColdStorage function removed

// getAllColdStorageDropdowns function removed

function changePage(action: string) {
	if (action === "next") {
		if (!checkIfAllMandatoryFieldsAreFilled(true)) return
		saveUtilities(true)
	}
	EventBus.emit("nextPreviousTab_" + props.tabId, { action: action, actualTab: props.tabId })
}

// WFI Source function removed

// viewWFIDetails function removed

// viewWFIDetailsChangedWFI function removed

function setPrimaryInformation(): Promise<string> {
	return new Promise((resolve, reject) => {
		// var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
		// var toGetStatus = tabStatus.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
		// //selectedStepName.value = toGetStatus.actualSubTabName

		stepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
		actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
			(item: any) => item.actualMainTabId === props.tabId
		).generalInformationId

		// Get step1 ID for single utilities mode
		if (isSingleUtilitiesChecked.value && !step1Id.value) {
			getStep1Id().then(() => {
				resolve("Done")
			})
		} else {
			resolve("Done")
		}
	})
}
const forceRerender = async () => {
	// Remove MyComponent from the DOM
	renderComponent.value = false

	// Wait for the change to get flushed to the DOM
	await nextTick()

	// Add the component back in
	renderComponent.value = true
}

function getProjectData() {
	apiClient.getAssessmentWithProject(props.assessmentId).then((result) => {
		if (result && result.subProject && result.subProject.project) {
			projectData.value = result.subProject.project
			isSingleUtilitiesChecked.value = result.subProject.project.isSingleUtilitiesChecked || false
		}
	})
}

function getStep1Id(): Promise<void> {
	return new Promise((resolve) => {
		if (step1Id.value) {
			resolve()
			return
		}

		// Guard against undefined generalInformationId
		if (!actualGeneralInformation.value) {
			console.warn("getStep1Id: actualGeneralInformation is undefined, skipping API call")
			resolve()
			return
		}

		apiClient
			.getStepByAssessmentIdScreenIdGeneralInfomationId(props.assessmentId, props.tabId, actualGeneralInformation.value)
			.then((steps) => {
				if (steps && steps.length > 0) {
					const step1 = steps.find((s) => s.stepNumber === 1)
					if (step1) {
						step1Id.value = step1.id
					}
				}
				resolve()
			})
			.catch((error) => {
				console.error("Error getting step 1 ID:", error)
				resolve()
			})
	})
}

function getEffectiveStepId(): string {
	if (isSingleUtilitiesChecked.value && step1Id.value) {
		return step1Id.value
	}
	return stepId.value
}

function checkSingleField(field: any) {
	return field !== null && field !== "" && field !== undefined
}

function checkListField(field: any) {
	return field.length > 0
}

function checkProcessinOperations() {
	var procStatus = true
	switch (props.tabName) {
		case tabsDefinitions.productProcess.value:
		case tabsDefinitions.biologics.value:
			unitOperationStep.value.forEach((item: any) => {
				procStatus = checkSingleField(item.duration) && checkSingleField(item.unitId)
			})
			break
		default:
			rawMaterialUnitOperation.value.forEach((item: any) => {
				procStatus = checkSingleField(item.duration) && checkSingleField(item.unitId)
			})
			break
	}
	return procStatus
}

function checkMandatoryFields() {
	switch (props.tabName) {
		case tabsDefinitions.biologics.value:
			return true
		case tabsDefinitions.syntheticAPI.value:
			return true
		case tabsDefinitions.productProcess.value:
			// Cold storage validation removed
			return true
	}
	return true
}

function checkIfAllMandatoryFieldsAreFilled(showToast: boolean = false): boolean {
	return checkIfSteamElectricityAre100Perc(showToast) && checkMandatoryFields()
}

async function saveUtilities(showToast: boolean) {
	if (showToast) saveAttempted.value = true
	await nextTick()
	if (!checkIfSteamElectricityAre100Perc()) {
		return
	}

	if (!checkMandatoryFields()) {
		toast.add({
			severity: "error",
			summary: "Highlighted fields are required to save",
			detail: ``,
			life: 3000,
			group: props.tabId,
		})

		return
	}

	if (!testUtilitiesConsumption()) {
		return
	}
	if (utilities.id == null) {
		utilities.id = self.crypto.randomUUID()
		utilities.stepId = getEffectiveStepId()
	}
	utilities.notes = notes.value
	utilities.hvacRequired = false
	// WFI and Cold Storage assignment removed

	apiClient.postUtilities(utilities).then(
		(res) => {
			actualUilitiesId.value = res.id

			// Ensure utilities steam consumption uses the saved utilities ID
			utilitiesSteamConsumptionObj.utilitiesId = res.id
			// Ensure utilities energy consumption uses the saved utilities ID
			utilitiesEnergyConsumptionObj.utilitiesId = res.id

			nextTick().then(() => {
				//save utilities steam consumption
				saveUtilitiesSteamConsumption()
				//save utilities energy consumption
				saveUtilitiesEnergyConsumption()

				if (showToast) toast.add({ severity: "success", summary: "Saved!", detail: "", life: 3500, group: props.tabId })
				updateAssessmentUpdatedByDate(props.assessmentId)
			})
		},
		(err) => {
			console.error("postUtilities ERROR:", err)
			toast.add({ severity: "error", summary: `Error: ${err}`, life: 2000 })
		}
	)
}

function saveUtilitiesSteamConsumption() {
	utilitiesSteamConsumptionObj.naturalGas = naturalGasValue.value
	utilitiesSteamConsumptionObj.coal = coalValue.value
	utilitiesSteamConsumptionObj.diesel = dieselValue.value
	utilitiesSteamConsumptionObj.biomass = biomassValue.value
	// Always update utilitiesId and stepId to ensure correct association
	utilitiesSteamConsumptionObj.utilitiesId = actualUilitiesId.value || utilities.id
	utilitiesSteamConsumptionObj.stepId = getEffectiveStepId()

	if (!testUtilitiesSteamConsumption(utilitiesSteamConsumptionObj)) {
		return
	}

	apiClient
		.updateSteamConsumption(utilitiesSteamConsumptionObj)
		.then((res) => {
			// Update the id from the response in case it was a new record
			if (res && res.id) {
				utilitiesSteamConsumptionObj.id = res.id
			}
		})
		.catch((err) => {
			console.error("updateSteamConsumption ERROR:", err)
		})
}

function saveUtilitiesEnergyConsumption() {
	utilitiesEnergyConsumptionObj.gridAverageMix = gridAverageMixValue.value
	utilitiesEnergyConsumptionObj.renewable = renewableValue.value

	// Always update utilitiesId and stepId to ensure correct association
	utilitiesEnergyConsumptionObj.utilitiesId = actualUilitiesId.value || utilities.id
	utilitiesEnergyConsumptionObj.stepId = getEffectiveStepId()

	if (!testUtilitiesEnergyConsumption(utilitiesEnergyConsumptionObj)) {
		return
	}

	apiClient
		.updateEnergyConsumption(utilitiesEnergyConsumptionObj)
		.then((res) => {
			// Update the id from the response in case it was a new record
			if (res && res.id) {
				utilitiesEnergyConsumptionObj.id = res.id
			}
		})
		.catch((err) => {
			console.error("updateEnergyConsumption ERROR:", err)
		})
}

// Reset consumption data when switching between different generalInformation
function resetConsumptionData() {
	// Reset Steam Consumption values
	naturalGasValue.value = 0
	coalValue.value = 0
	dieselValue.value = 0
	biomassValue.value = 0
	totalSteamConsumption.value = 0

	// Reset Energy Consumption values
	gridAverageMixValue.value = 0
	renewableValue.value = 0
	totalEnergyConsumption.value = 0

	// Reset Steam Consumption object
	utilitiesSteamConsumptionObj.id = ""
	utilitiesSteamConsumptionObj.stepId = ""
	utilitiesSteamConsumptionObj.utilitiesId = ""
	utilitiesSteamConsumptionObj.naturalGas = 0
	utilitiesSteamConsumptionObj.coal = 0
	utilitiesSteamConsumptionObj.diesel = 0
	utilitiesSteamConsumptionObj.biomass = 0

	// Reset Energy Consumption object
	utilitiesEnergyConsumptionObj.id = ""
	utilitiesEnergyConsumptionObj.stepId = ""
	utilitiesEnergyConsumptionObj.utilitiesId = ""
	utilitiesEnergyConsumptionObj.gridAverageMix = 0
	utilitiesEnergyConsumptionObj.renewable = 0

	// Reset lists
	steamConsumptionList.value = []
	energyConsumptionList.value = []

	// Hide display until data is loaded
	displaySteamConsumptionList.value = false
	displayEnergyConsumptionList.value = false
}

function getUtilitiesByStepId(stepId: string) {
	// Reset consumption data before loading new data for a different generalInformation
	resetConsumptionData()

	// For Packaging and Distribution tabs, use generalInformationId to get the correct utilities
	const isPackagingOrDistribution = props.tabName === tabsDefinitions.packaging.value || props.tabName === tabsDefinitions.distribution.value

	const utilitiesPromise =
		isPackagingOrDistribution && actualGeneralInformation.value
			? apiClient.getUtilitiesByStepIdAndGeneralInformationId(stepId, actualGeneralInformation.value)
			: apiClient.getUtilitiesByStepId(stepId)

	utilitiesPromise.then((result) => {
		if (result != null) {
			utilities = result
			notes.value = utilities.notes
			// WFI and Cold Storage data setting removed

			thisStepStatus.value = true
			actualUilitiesId.value = utilities.id

			// Load Steam/Energy consumption
			getRawMaterialUnitOperationByStepId(getEffectiveStepId())
			// For Packaging/Distribution, use utilitiesId to load consumption data
			if (isPackagingOrDistribution && utilities.id) {
				getSteamConsumptionByUtilitiesId(utilities.id)
				getEnergyConsumptionByUtilitiesId(utilities.id)
			} else {
				getSteamConsumptionByStepId(getEffectiveStepId())
				getEnergyConsumptionByStepId(getEffectiveStepId())
			}
		} else {
			utilities = new Utilities()
			utilities.id = self.crypto.randomUUID()
			utilities.stepId = stepId
			// For Packaging/Distribution, set the generalInformationId on new utilities
			if (isPackagingOrDistribution && actualGeneralInformation.value) {
				utilities.generalInformationId = actualGeneralInformation.value
			}
			//saveUtilities(false)
			notes.value = ""
			thisStepStatus.value = false

			getRawMaterialUnitOperationByStepId(getEffectiveStepId())
			// For Packaging/Distribution, always use defaults for new utilities to avoid loading data from other generalInformation
			if (isPackagingOrDistribution) {
				getDefaultSteamConsumption()
				getDefaultEnergyConsumption()
			} else {
				getSteamConsumptionByStepId(getEffectiveStepId())
				getEnergyConsumptionByStepId(getEffectiveStepId())
			}
		}
	})
}

function calculatioOfCFP(values: any, utilities: any): Promise<number | null> {
	return new Promise((resolve, reject) => {
		let processingOperationCF: ProcessingOperationCF = new ProcessingOperationCF()
		processingOperationCF.stepId = getEffectiveStepId()
		if (utilities.id != null) {
			processingOperationCF.utilitiesId = utilities.id
		} else {
			processingOperationCF.utilitiesId = self.crypto.randomUUID()
		}
		processingOperationCF.rawMaterialUnitOperation = values

		processingOperationCF.steamConsumptionList = steamConsumptionList.value[0]
		processingOperationCF.energyConsumptionList = energyConsumptionList.value[0]
		if (processingOperationCF.rawMaterialUnitOperation.duration != null && processingOperationCF.rawMaterialUnitOperation.unitId != null) {
			apiClient.calculateProcessingOperationCF(processingOperationCF).then(
				(result) => {
					if (result != null) {
						resolve(result)
						//calculatedCF.value = result.toLocaleString("en-US", options)
					}
				},
				(err) => {
					resolve(null)
				}
			)
		}
	})
}

function getRawMaterialUnitOperationByStepId(stepId: string) {
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			apiClient
				.getRawMaterialUnitOperationByStepId(stepId, actualGeneralInformation.value)
				.then((result) => {
					if (result != null) {
						result.forEach((item) => {
							if (item.carbonFootprint != null) {
								item.carbonFootprint = item.carbonFootprint
							}
						})

						rawMaterialUnitOperation.value = result
						displayUnitOperation.value = true
						return result
					}
				})
				.then((result: any) => {
					rawMaterialUnitOperation.value.forEach((item: any) => {
						if (item.duration !== null && item.unitId !== null && item.carbonFootprint === null) {
							calculatioOfCFP(item, utilities).then((res) => {
								item.carbonFootprint = parseFloat(res)
							})
						}
					})
				})
				.then(() => {})
			break
		case tabsDefinitions.biologics.value:
			apiClient.getunitOperationUtilitiesByStepId(stepId).then((result) => {
				if (result != null) {
					result.forEach((item) => {
						if (item.carbonFootprint != null) {
							item.carbonFootprint = item.carbonFootprint
						}
					})

					unitOperationStep.value = result

					displayUnitOperation.value = true
				} else {
				}
			})
			break
		case tabsDefinitions.productProcess.value:
			apiClient.getunitOperationUtilitiesByStepId(stepId).then((result) => {
				if (result != null) {
					result.forEach((item) => {
						if (item.carbonFootprint != null) {
							item.carbonFootprint = item.carbonFootprint
						}
					})

					unitOperationStep.value = result
					displayUnitOperation.value = true
				} else {
				}
			})
			break
	}
}

async function getDefaultSteamConsumption() {
	dataLoading.value = true
	apiClient.getSteamConsumptionDefault().then(
		async (result) => {
			if (result != null) {
				steamConsumptionDefaultList.value = result
				if (steamConsumptionDefaultList.value != null) {
					naturalGasValue.value = steamConsumptionDefaultList.value[0].natualGas
					coalValue.value = steamConsumptionDefaultList.value[0].coal
					dieselValue.value = steamConsumptionDefaultList.value[0].diesel
					biomassValue.value = steamConsumptionDefaultList.value[0].biomass

					utilitiesSteamConsumptionObj.id = self.crypto.randomUUID()
					utilitiesSteamConsumptionObj.stepId = getEffectiveStepId()
					if (utilities.id != null) {
						utilitiesSteamConsumptionObj.utilitiesId = utilities.id
					}
					utilitiesSteamConsumptionObj.naturalGas = naturalGasValue.value
					utilitiesSteamConsumptionObj.coal = coalValue.value
					utilitiesSteamConsumptionObj.diesel = dieselValue.value
					utilitiesSteamConsumptionObj.biomass = biomassValue.value

					steamConsumptionList.value = []
					steamConsumptionList.value.push(utilitiesSteamConsumptionObj)
					displaySteamConsumptionList.value = true
					calculateTotalSteamConsumption()
					await nextTick()
				}
			}
			dataLoading.value = false
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}` })
			dataLoading.value = false
		}
	)
}

function setConsumptionDefaults(type: string) {
	switch (type) {
		case "fuel":
			apiClient.getSteamConsumptionDefault().then((result) => {
				naturalGasValue.value = result[0].natualGas
				coalValue.value = result[0].coal
				dieselValue.value = result[0].diesel
				biomassValue.value = result[0].biomass
				calculateTotalSteamConsumption()
				toast.add({
					severity: "success",
					summary: "Default Values Applied",
					detail: "Fuel Consumption default values have been applied successfully.",
					life: 3000,
				})
			})
			break
		case "energy":
			apiClient.getEnergyConsumptionDefault().then((result) => {
				gridAverageMixValue.value = result[0].gridAverageMix
				renewableValue.value = (result[0] as any).renewable || 0
				// solar removed
				// wind removed
				// hydro removed
				// biomass removed
				calculateTotalEnergyConsumption()
				toast.add({
					severity: "success",
					summary: "Default Values Applied",
					detail: "Electricity Consumption default values have been applied successfully.",
					life: 3000,
				})
			})
	}
}

async function getDefaultEnergyConsumption() {
	apiClient.getEnergyConsumptionDefault().then(async (result) => {
		if (result != null) {
			energyConsumptionDefaultList.value = result
			if (energyConsumptionDefaultList.value != null) {
				gridAverageMixValue.value = energyConsumptionDefaultList.value[0].gridAverageMix
				renewableValue.value = (energyConsumptionDefaultList.value[0] as any).renewable || 0
				// solar removed
				// wind removed
				// hydro removed
				// biomass removed

				utilitiesEnergyConsumptionObj.id = self.crypto.randomUUID()
				utilitiesEnergyConsumptionObj.stepId = getEffectiveStepId()
				if (utilities != null) {
					utilitiesEnergyConsumptionObj.utilitiesId = utilities.id
				}
				utilitiesEnergyConsumptionObj.gridAverageMix = gridAverageMixValue.value
				utilitiesEnergyConsumptionObj.renewable = renewableValue.value
				// solar assignment removed
				// wind assignment removed
				// hydro assignment removed
				// biomass assignment removed

				energyConsumptionList.value = []
				energyConsumptionList.value.push(utilitiesEnergyConsumptionObj)
				displayEnergyConsumptionList.value = true
				calculateTotalEnergyConsumption()
				await nextTick()
			}
		}
	})
}

async function getSteamConsumptionByStepId(stepId: string) {
	dataLoading.value = true
	apiClient.getSteamConsumptionByStepId(stepId).then(
		async (result) => {
			if (result != null && result.length > 0) {
				steamConsumptionList.value = result
				naturalGasValue.value = steamConsumptionList.value[0].naturalGas
				coalValue.value = steamConsumptionList.value[0].coal
				dieselValue.value = steamConsumptionList.value[0].diesel
				biomassValue.value = steamConsumptionList.value[0].biomass

				utilitiesSteamConsumptionObj.id = steamConsumptionList.value[0].id
				utilitiesSteamConsumptionObj.stepId = steamConsumptionList.value[0].stepId
				utilitiesSteamConsumptionObj.utilitiesId = steamConsumptionList.value[0].utilitiesId

				displaySteamConsumptionList.value = true
				calculateTotalSteamConsumption()
				await nextTick()
			} else {
				getDefaultSteamConsumption()
			}

			dataLoading.value = false
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}` })
			dataLoading.value = false
		}
	)
}

function getDataFromRawMaterialScreen() {
	//var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
	var toGetStatus = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
	var selectedStepName = toGetStatus.actualSubTabName
	stepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
	actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
		(item: any) => item.actualMainTabId === props.tabId
	).generalInformationId
	const effectiveStepId = getEffectiveStepId()
	if (actualGeneralInformation === undefined || effectiveStepId === undefined || props.tabId === undefined) return
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			apiClient
				.getRawMaterialsByGeneraInformationIdScreenIdStepId(actualGeneralInformation.value, props.tabId, effectiveStepId, selectedStepName)
				.then((res) => {
					if (res !== null) {
						notes.value = res.note
						BDSMassOutput.value = res.massOfProduct + " " + res.unit.unitName
						BDSConcentration.value = res.bdsConcentration + " " + res.bdsUnit.unitName
						siteLocation.value = res.siteLocation.siteLocationName
						unitOperation.value = res.rawMaterialUnitOperation
							?.filter((item) => item.isActive == true)
							.map((item) => item.unitOperation.unitOperationName)
							.join(", ")
					} else {
					}
				})
			break
		case tabsDefinitions.biologics.value:
			apiClient.getBasicDataByGeneraInformationIdScreenId(actualGeneralInformation.value, props.tabId, effectiveStepId).then(
				(res) => {
					if (res !== null) {
						//notes.value = res.notes
						BDSMassOutput.value = res.proteinMassOutput + " " + res.proteinMOUnit.unitName
						BDSConcentration.value = res.concProteinMassProdOutput + " " + res.concentrationUnit.unitName
						siteLocation.value = res.siteLocation.siteLocationName
					}
				},
				(err) => {
					toast.add({ severity: "error", summary: `Error: ${err}` })
				}
			)
			break
		case tabsDefinitions.productProcess.value:
			apiClient.getBasicDataByGeneraInformationIdScreenId(actualGeneralInformation.value, props.tabId, effectiveStepId).then((res) => {
				if (res !== null) {
					//notes.value = res.notes
					// BDSMassOutput.value = res.proteinMassOutput + " " + res.proteinMOUnit.unitName
					// BDSConcentration.value = res.concProteinMassProdOutput + " " + res.concentrationUnit.unitName
					//siteLocation.value = res.siteLocation.siteLocationName
				} else {
				}
			})
			break
	}
}

async function getEnergyConsumptionByStepId(stepId: string) {
	apiClient.getEnergyConsumptionByStepId(stepId).then(async (result) => {
		if (result != null && result.length > 0) {
			energyConsumptionList.value = result
			gridAverageMixValue.value = energyConsumptionList.value[0].gridAverageMix
			renewableValue.value = energyConsumptionList.value[0].renewable || 0
			// Other energy values removed

			utilitiesEnergyConsumptionObj.id = energyConsumptionList.value[0].id
			utilitiesEnergyConsumptionObj.stepId = energyConsumptionList.value[0].stepId
			utilitiesEnergyConsumptionObj.utilitiesId = energyConsumptionList.value[0].utilitiesId

			displayEnergyConsumptionList.value = true
			calculateTotalEnergyConsumption()
			await nextTick()
		} else {
			getDefaultEnergyConsumption()
		}
		if (props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value) getDataFromRawMaterialScreen()
	})
}

// Get Steam Consumption by utilitiesId - Used only for Packaging and Distribution tabs
async function getSteamConsumptionByUtilitiesId(utilitiesId: string) {
	dataLoading.value = true
	apiClient.getSteamConsumptionByUtilitiesId(utilitiesId).then(
		async (result) => {
			if (result != null && result.length > 0) {
				steamConsumptionList.value = result
				naturalGasValue.value = steamConsumptionList.value[0].naturalGas ? steamConsumptionList.value[0].naturalGas : 0
				coalValue.value = steamConsumptionList.value[0].coal ? steamConsumptionList.value[0].coal : 0
				dieselValue.value = steamConsumptionList.value[0].diesel ? steamConsumptionList.value[0].diesel : 0
				biomassValue.value = steamConsumptionList.value[0].biomass ? steamConsumptionList.value[0].biomass : 0

				utilitiesSteamConsumptionObj.id = steamConsumptionList.value[0].id
				utilitiesSteamConsumptionObj.stepId = steamConsumptionList.value[0].stepId
				utilitiesSteamConsumptionObj.utilitiesId = steamConsumptionList.value[0].utilitiesId

				displaySteamConsumptionList.value = true
				calculateTotalSteamConsumption()
				await nextTick()
			} else {
				getDefaultSteamConsumption()
			}

			dataLoading.value = false
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}` })
			dataLoading.value = false
		}
	)
}

// Get Energy Consumption by utilitiesId - Used only for Packaging and Distribution tabs
async function getEnergyConsumptionByUtilitiesId(utilitiesId: string) {
	apiClient.getEnergyConsumptionByUtilitiesId(utilitiesId).then(async (result) => {
		if (result != null && result.length > 0) {
			energyConsumptionList.value = result
			gridAverageMixValue.value = energyConsumptionList.value[0].gridAverageMix
			renewableValue.value = energyConsumptionList.value[0].renewable || 0

			utilitiesEnergyConsumptionObj.id = energyConsumptionList.value[0].id
			utilitiesEnergyConsumptionObj.stepId = energyConsumptionList.value[0].stepId
			utilitiesEnergyConsumptionObj.utilitiesId = energyConsumptionList.value[0].utilitiesId

			displayEnergyConsumptionList.value = true
			calculateTotalEnergyConsumption()
			await nextTick()
		} else {
			getDefaultEnergyConsumption()
		}
	})
}

function getAllUnit() {
	apiClient.getUnitByUnitTypeName("Duration").then((res: any) => {
		unitList.value = res
	})
}

function testUtilitiesSteamConsumption(utilitiesSteamConsumptionObj: UtilitiesSteamConsumption) {
	if (
		utilitiesSteamConsumptionObj.naturalGas == null &&
		utilitiesSteamConsumptionObj.coal == null &&
		utilitiesSteamConsumptionObj.diesel == null &&
		utilitiesSteamConsumptionObj.biomass == null
	) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "You must complete the highlighted fields",
		// 	life: 5000,
		// })
		saveUtilitiesData.value = true
		return false
	} else if (totalSteamConsumption.value != 100 && steamConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Steam Consumption total should be 100",
		// 	life: 5000,
		// })
		steamConsumptionErrorFlagged.value = true
		setTimeout(() => {
			steamConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	}

	return true
}

function testUtilitiesEnergyConsumption(utilitiesEnergyConsumptionObj: UtilitiesEnergyConsumption) {
	if (
		utilitiesEnergyConsumptionObj.gridAverageMix == null &&
		utilitiesEnergyConsumptionObj.gridGreenTariff == null &&
		utilitiesEnergyConsumptionObj.solar == null &&
		utilitiesEnergyConsumptionObj.wind == null &&
		utilitiesEnergyConsumptionObj.onSiteHydro == null &&
		utilitiesEnergyConsumptionObj.onSiteBiomass == null
	) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "You must complete the highlighted fields",
		// 	life: 5000,
		// })
		saveUtilitiesData.value = true
		return false
	} else if (totalEnergyConsumption.value != 100 && energyConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Energy Consumption total should be 100",
		// 	life: 5000,
		// })
		energyConsumptionErrorFlagged.value = true
		setTimeout(() => {
			energyConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	}

	return true
}

function testUtilitiesConsumption() {
	if (totalSteamConsumption.value != 100 && steamConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Steam Consumption total should be 100",
		// 	life: 5000,
		// })
		steamConsumptionErrorFlagged.value = true
		setTimeout(() => {
			steamConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	} else if (totalEnergyConsumption.value != 100 && energyConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Energy Consumption total should be 100",
		// 	life: 5000,
		// })
		energyConsumptionErrorFlagged.value = true
		setTimeout(() => {
			energyConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	}

	if (totalSteamConsumption.value != 100 || totalEnergyConsumption.value != 100) {
		return false
	}

	return true
}

function checkIfEmpty(tableName: string, fieldName: string) {
	if (tableName == "energyConsumption") {
		switch (fieldName) {
			case "renewable":
				if (renewableValue.value == "") {
					renewableValue.value = 0
				}
				break
			// Removed cases: solar, wind, onSiteHydro, onSiteBiomass, gridGreenTariff
			case "gridAverageMix":
				if (gridAverageMixValue.value == "") {
					gridAverageMixValue.value = 0
				}
				break
		}
	}
	if (tableName == "steamConsumption") {
		switch (fieldName) {
			case "biomass":
				if (biomassValue.value == "") {
					biomassValue.value = 0
				}
				break
			case "diesel":
				if (dieselValue.value == "") {
					dieselValue.value = 0
				}
				break
			case "coal":
				if (coalValue.value == "") {
					coalValue.value = 0
				}
				break
			case "natualGas":
				if (naturalGasValue.value == "") {
					naturalGasValue.value = 0
				}
				break
		}
	}
}

function numbersOnly(evt) {
	evt = evt ? evt : window.event
	var charCode = evt.which ? evt.which : evt.keyCode
	//if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
	if (
		(charCode != 46 || evt.target.value.indexOf(".") != -1) && // “.” CHECK DOT, AND ONLY ONE.
		(charCode < 48 || charCode > 57)
	) {
		evt.preventDefault()
		return false
	} else {
		return true
	}
}

function checkIfTotalIs100(total: number) {
	if (total > 100 || total < 100) return "red"
	else "black"
}

function calculateTotalSteamConsumption() {
	let sum =
		parseFloat(String(naturalGasValue.value)) +
		parseFloat(String(coalValue.value)) +
		parseFloat(String(dieselValue.value)) +
		parseFloat(String(biomassValue.value))

	// if (sum != 100 && steamConsumptionErrorFlagged.value == false) {
	// 	toast.add({
	// 		severity: "error",
	// 		summary: "Error",
	// 		detail: "Steam Consumption total should be 100",
	// 		life: 5000,
	// 	})
	// 	steamConsumptionErrorFlagged.value = true
	// 	setTimeout(() => {
	// 		steamConsumptionErrorFlagged.value = false
	// 	}, 5000)
	// }

	totalSteamConsumption.value = sum
	//saveUtilitiesSteamConsumption()
}

function calculateTotalEnergyConsumption() {
	let sum = parseFloat(String(gridAverageMixValue.value)) + parseFloat(String(renewableValue.value))

	// if (sum != 100 && energyConsumptionErrorFlagged.value == false) {
	// 	toast.add({
	// 		severity: "error",
	// 		summary: "Error",
	// 		detail: "Energy Consumption total should be 100",
	// 		life: 5000,
	// 	})
	// 	energyConsumptionErrorFlagged.value = true
	// 	setTimeout(() => {
	// 		energyConsumptionErrorFlagged.value = false
	// 	}, 5000)
	// }

	//function saveUtilitiesSteamConsumption()
	totalEnergyConsumption.value = sum
	// Don't auto-save on calculation - only save when user clicks Save button
	// saveUtilitiesEnergyConsumption()
}

// Energy Multipliers Functions
function checkIfAllowedScreen(): boolean {
	const allowedScreens = ["Synthetic API", "Biologics", "Product Process", "Device & Packaging"]
	return allowedScreens.includes(props.tabName)
}

async function refreshIsCalculateByReferenceUnit() {
	// Re-fetch the General Information so the toggle's disabled state reflects the
	// current Calculate Results By selection (Reference Unit vs Product Format).
	// The watcher on actualGeneralInformation only fires on id changes, but the user
	// can toggle the field on the same GI record, so we refresh here on every load.
	// When productFormatId is also set (e.g. inherited from Product Process), the
	// GI tab locks Calculate Results By to Product Format even if a stale
	// packReferenceUnitId lingers on the row, so we must mirror that interpretation.
	if (props.tabName !== tabsDefinitions.packaging.value || !actualGeneralInformation.value) {
		isCalculateByReferenceUnit.value = false
		return
	}
	try {
		const genInfo = await apiClient.getGeneralInformationById(actualGeneralInformation.value, undefined)
		const hasProductFormat = genInfo?.productFormatId != null && genInfo?.productFormatId !== ""
		isCalculateByReferenceUnit.value = genInfo?.packReferenceUnitId != null && !hasProductFormat
	} catch (error) {
		isCalculateByReferenceUnit.value = false
	}
}

async function initializeEnergyMultipliers() {
	// Check if we have the minimum required data
	if (!props.assessmentId || !props.tabId || !actualGeneralInformation.value) {
		return
	}

	await refreshIsCalculateByReferenceUnit()

	showEnergyMultipliers.value = checkIfAllowedScreen()
	if (showEnergyMultipliers.value) {
		await loadEnergyMultipliers()
	}
}

async function loadEnergyMultipliers() {
	try {
		energyMultipliersLoading.value = true

		// Determine the product format source screen ID
		// For "Synthetic API" and "Biologics" screens, use tabId for both parameters
		let productFormatSourceScreenId = props.tabId
		if (props.tabId !== "Synthetic API" && props.tabId !== "Biologics") {
			// For other screens, get from the API
			const generalInformationClient = new GeneralInformationClient(import.meta.env.VITE_API_URL?.toString())
			const apiResult = await generalInformationClient.getProductFormatSourceScreenId(props.assessmentId, props.tabId)
			// If API returns undefined, fallback to tabId
			productFormatSourceScreenId = apiResult || props.tabId
		}

		// When results are calculated by Reference Unit, there is no productFormat
		// to key records against. Look across any productFormatSourceScreenId for
		// this module's assessment-specific records; if none exist, seed from globals
		// so the table is populated and editable.
		if (isCalculateByReferenceUnit.value) {
			const response = await seedReferenceUnitMultipliersFromGlobals()
			energyMultipliers.value = response || []
			energyMultipliersType.value = "assessment"
			originalEnergyMultipliers.value = JSON.parse(JSON.stringify(response || []))
			return
		}

		// First try to get assessment-specific multipliers using the new filtered API
		let response = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			actualGeneralInformation.value // generalInformationId for assessment-specific data
		)

		if (response && response.length > 0) {
			energyMultipliers.value = response
			energyMultipliersType.value = "assessment"
			originalEnergyMultipliers.value = JSON.parse(JSON.stringify(response))
			return
		}

		// Fall back to global defaults using the new filtered API
		response = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			undefined // generalInformationId = undefined for global defaults
		)

		energyMultipliers.value = response || []
		energyMultipliersType.value = "global"
		originalEnergyMultipliers.value = JSON.parse(JSON.stringify(response || []))
	} catch (error) {
		console.error("❌ Error loading energy multipliers:", error)
		toast.add({
			severity: "error",
			summary: "Error loading energy multipliers",
			detail: "Please try again",
			life: 3000,
		})
	} finally {
		energyMultipliersLoading.value = false
	}
}

// Handle switch change for energy multipliers type
function onSwitchChange(value: boolean) {
	energyMultipliersType.value = value ? "assessment" : "global"
	onEnergyMultipliersTypeChange()
}

async function onEnergyMultipliersTypeChange() {
	try {
		if (energyMultipliersType.value === "global") {
			// Switching to Global Default - ask for confirmation and delete assessment-specific data
			confirmDialog.require({
				message: "Switching to Global Default will remove assessment-specific data. Are you sure?",
				header: "Confirm Change",
				icon: "pi pi-exclamation-triangle",
				acceptLabel: "Yes, Switch",
				rejectLabel: "Cancel",
				acceptClass: "p-button-danger",
				accept: async () => {
					await deleteAssessmentSpecificMultipliers()
					await loadEnergyMultipliers()
				},
				reject: () => {
					energyMultipliersType.value = "assessment"
				},
			})
		} else {
			// Switching to Assessment Specific - copy global defaults and save to database
			await copyGlobalDefaultsToAssessment()
			await loadEnergyMultipliers()
		}
	} catch (error) {
		console.error("Error changing energy multipliers type:", error)
		toast.add({
			severity: "error",
			summary: "Error",
			detail: "Failed to change multiplier type. Please try again.",
			life: 5000,
		})
	}
}

// Copy global default multipliers to assessment-specific
async function copyGlobalDefaultsToAssessment() {
	try {
		console.log("🔄 Copying global defaults to assessment-specific...")

		// Determine the product format source screen ID
		// For "Synthetic API" and "Biologics" screens, use tabId for both parameters
		let productFormatSourceScreenId = props.tabId
		if (props.tabId !== "Synthetic API" && props.tabId !== "Biologics") {
			// For other screens, get from the API
			const generalInformationClient = new GeneralInformationClient(import.meta.env.VITE_API_URL?.toString())
			const apiResult = await generalInformationClient.getProductFormatSourceScreenId(props.assessmentId, props.tabId)
			// If API returns undefined, fallback to tabId
			productFormatSourceScreenId = apiResult || props.tabId
		}

		// Get global defaults from database using the same logic as loadEnergyMultipliers
		const globalDefaults = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			undefined // generalInformationId = undefined for global defaults
		)

		if (!globalDefaults || globalDefaults.length === 0) {
			console.log("⚠️ No global defaults found to copy")
			return
		}

		// Create assessment-specific copies
		const assessmentSpecificMultipliers = globalDefaults.map((multiplier) => {
			return new EnergyMultipliers({
				id: getEmptyGuid(), // Force creation with empty GUID
				generalInformationId: actualGeneralInformation.value, // Link to current general information
				energyId: multiplier.energyId,
				moduleScreenId: multiplier.moduleScreenId,
				productFormatSourceScreenId: multiplier.productFormatSourceScreenId,
				value: multiplier.value,
				isActive: true,
			})
		})

		console.log("💾 Saving assessment-specific multipliers:", assessmentSpecificMultipliers)

		// Save to database and get the response with real IDs
		const savedMultipliers = await energyMultipliersClient.save(assessmentSpecificMultipliers)

		console.log("✅ Successfully copied global defaults to assessment-specific")
		console.log("🆔 Saved multipliers with IDs:", savedMultipliers)

		toast.add({
			severity: "success",
			summary: "Success",
			detail: "Global defaults copied to assessment-specific values.",
			life: 3000,
		})
	} catch (error) {
		console.error("❌ Error copying global defaults:", error)
		throw error
	}
}

// Seed assessment-specific multipliers for the Reference Unit case.
async function seedReferenceUnitMultipliersFromGlobals(): Promise<EnergyMultipliers[]> {
	// Reference Unit records are stored with productFormatSourceScreenId = null;
	// Product Format records on the same assessment carry a productFormatSourceScreenId.
	// Only return the null subset so Product Format rows from the same assessment
	// don't appear duplicated alongside the Reference Unit rows.
	const existing = await energyMultipliersClient.listFiltered(props.tabId, undefined, actualGeneralInformation.value)
	const referenceUnitExisting = (existing || []).filter((r) => !r.productFormatSourceScreenId)
	if (referenceUnitExisting.length > 0) {
		return referenceUnitExisting
	}

	// Pull globals across any productFormatSourceScreenId for this module
	const globals = await energyMultipliersClient.listFiltered(props.tabId, undefined, undefined)
	if (!globals || globals.length === 0) {
		return []
	}

	// Dedupe by energyId — take the first occurrence per energy type
	const energyIds = globals.filter((g) => !!g.energyId).map((g) => g.energyId) // Filter out any records with null/undefined energyId
	const uniqueEnergyIds = Array.from(new Set(energyIds))

	const assessmentSpecificMultipliers = uniqueEnergyIds.map(
		(eid) =>
			new EnergyMultipliers({
				id: getEmptyGuid(),
				generalInformationId: actualGeneralInformation.value,
				energyId: eid,
				moduleScreenId: props.tabId,
				value: 0,
				isActive: true,
			})
	)

	await energyMultipliersClient.save(assessmentSpecificMultipliers)
	return assessmentSpecificMultipliers
}

// Delete all assessment-specific multipliers for this assessment
async function deleteAssessmentSpecificMultipliers() {
	try {
		console.log("🗑️ Deleting assessment-specific multipliers...")

		// Determine the product format source screen ID
		// For "Synthetic API" and "Biologics" screens, use tabId for both parameters
		let productFormatSourceScreenId = props.tabId
		if (props.tabId !== "Synthetic API" && props.tabId !== "Biologics") {
			// For other screens, get from the API
			const generalInformationClient = new GeneralInformationClient(import.meta.env.VITE_API_URL?.toString())
			const apiResult = await generalInformationClient.getProductFormatSourceScreenId(props.assessmentId, props.tabId)
			// If API returns undefined, fallback to tabId
			productFormatSourceScreenId = apiResult || props.tabId
		}

		// Get all assessment-specific multipliers for this generalInformation and moduleScreen
		const assessmentMultipliers = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			actualGeneralInformation.value // generalInformationId for assessment-specific data
		)

		if (!assessmentMultipliers || assessmentMultipliers.length === 0) {
			console.log("ℹ️ No assessment-specific multipliers found to delete")
			return
		}

		// Delete each multiplier
		for (const multiplier of assessmentMultipliers) {
			if (multiplier.id) {
				await energyMultipliersClient.delete(multiplier.id)
				console.log(`🗑️ Deleted multiplier ${multiplier.id}`)
			}
		}

		console.log("✅ Successfully deleted assessment-specific multipliers")

		toast.add({
			severity: "success",
			summary: "Success",
			detail: "Assessment-specific values removed. Showing global defaults.",
			life: 3000,
		})
	} catch (error) {
		console.error("❌ Error deleting assessment-specific multipliers:", error)
		throw error
	}
}

function enterEnergyMultipliersEditMode() {
	energyMultipliersEditMode.value = true
	energyMultipliersSaveAttempted.value = false
	originalEnergyMultipliers.value = JSON.parse(JSON.stringify(energyMultipliers.value))
}

function hasEnergyMultipliersUnsavedChanges(): boolean {
	const currentJson = JSON.stringify(energyMultipliers.value)
	const originalJson = JSON.stringify(originalEnergyMultipliers.value)
	return currentJson !== originalJson
}

function cancelEnergyMultipliersEdit() {
	if (hasEnergyMultipliersUnsavedChanges()) {
		confirmDialog.require({
			message: "Are you sure you want to cancel? Any unsaved changes will be lost.",
			header: "Cancel Changes",
			icon: "pi pi-exclamation-triangle",
			acceptLabel: "Yes, Cancel",
			rejectLabel: "Continue Editing",
			acceptClass: "p-button-danger",
			accept: () => {
				performEnergyMultipliersCancel()
			},
		})
	} else {
		performEnergyMultipliersCancel()
	}
}

function performEnergyMultipliersCancel() {
	energyMultipliers.value = JSON.parse(JSON.stringify(originalEnergyMultipliers.value))
	energyMultipliersEditMode.value = false
	energyMultipliersSaveAttempted.value = false
}

function isEnergyMultiplierFieldInvalid(data: EnergyMultipliers, fieldName: keyof EnergyMultipliers) {
	if (!energyMultipliersSaveAttempted.value) return false

	const fieldValue = data[fieldName]

	if (fieldName === "value") {
		return fieldValue === null || fieldValue === undefined
	}

	return !fieldValue || fieldValue === ""
}

function validateEnergyMultipliers(): boolean {
	let isValid = true

	for (const multiplier of energyMultipliers.value) {
		if (multiplier.value === null || multiplier.value === undefined) {
			isValid = false
			break
		}
	}

	if (!isValid) {
		toast.add({
			severity: "error",
			summary: "Missing Required Fields",
			detail: "Please fill in all required fields for each energy multiplier.",
			life: 3000,
		})
	}

	return isValid
}

async function saveEnergyMultipliers() {
	energyMultipliersSaveAttempted.value = true

	if (!validateEnergyMultipliers()) {
		return
	}

	try {
		energyMultipliersLoading.value = true

		// Prepare multipliers for API - use proper EnergyMultipliers class
		const multipliersToSave = energyMultipliers.value.map((multiplier) => {
			console.log("Processing multiplier:", {
				id: multiplier.id,
				energyId: multiplier.energyId,
				moduleScreenId: multiplier.moduleScreenId,
				value: multiplier.value,
				isUpdate: multiplier.id && multiplier.id !== getEmptyGuid(),
			})

			// Check if this record already exists (has a valid ID) or needs to be created
			const hasValidId = multiplier.id && multiplier.id !== getEmptyGuid()
			const finalId = hasValidId ? multiplier.id : getEmptyGuid()

			const em = new EnergyMultipliers({
				id: finalId,
				generalInformationId: energyMultipliersType.value === "assessment" ? actualGeneralInformation.value : undefined,
				energyId: multiplier.energyId,
				moduleScreenId: multiplier.moduleScreenId,
				productFormatSourceScreenId: multiplier.productFormatSourceScreenId || undefined,
				value: multiplier.value,
				isActive: multiplier.isActive ?? true,
			})

			const rawValue = multiplier.energyId ? energyMultiplierRawValues.get(multiplier.energyId) : null
			const valueStr = rawValue ?? (typeof multiplier.value === "string" ? (multiplier.value as string) : null)
			if (valueStr) {
				patchEntityForPrecision(em, { value: valueStr })
			}

			return em
		})

		console.log("Saving energy multipliers:", multipliersToSave)
		console.log("energyMultipliersType:", energyMultipliersType.value)
		console.log("props.assessmentId:", props.assessmentId)
		console.log("JSON payload:", JSON.stringify(multipliersToSave, null, 2))

		const response = await energyMultipliersClient.save(multipliersToSave)
		console.log("Save response:", response)

		toast.add({
			severity: "success",
			summary: "Success",
			detail: "Energy multipliers saved successfully.",
			life: 3000,
		})

		// Reload data to get updated information
		await loadEnergyMultipliers()

		// Exit edit mode
		energyMultipliersEditMode.value = false
		energyMultipliersSaveAttempted.value = false
	} catch (error) {
		console.error("Error saving energy multipliers:", error)
		const errorMessage = error instanceof Error ? error.message : "Please try again"
		toast.add({
			severity: "error",
			summary: "Error saving energy multipliers",
			detail: errorMessage,
			life: 5000,
		})
	} finally {
		energyMultipliersLoading.value = false
	}
}
</script>

<style lang="scss" scoped>
.p-invalid {
	border-color: red !important;
}
.invalid-table {
	border: 1px solid red !important;
	border-radius: 2px !important;
}
.stepName {
	font-weight: bold;
	font-size: 20;
	color: rgb(0, 51, 98);
}
.btn-outline {
	background-color: white;
	color: var(--primary);
	border: 2px solid var(--primary);
	padding: 5px 10px;
	font-size: 12px;
	border-radius: 3px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.btn-outline:hover {
	background-color: #007bff;
	color: white;
}
</style>
